




























































































































import { computed, defineComponent, onBeforeMount, PropType, ref, Ref, toRefs } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';
import TipBox from '@/components/common/tip-box/index.vue';
import BackgroundContainer from '@/components/common/background-container/index.vue';
import TtamHighSetting from '@/components/common/vi-high-setting/index.vue';
import TtamAudience from './audience-base-compose.vue';
import { AdgroupFormData, AppRetargetingType, CampaignFormData } from '@tt4b/ttam-enums';
import Audience from './index';
import { Validator } from './types';

const name = 'ttam-audience-retarget-pre';
export default defineComponent({
  name,
  components: {
    ALink,
    TipBox,
    BackgroundContainer,
    TtamAudience,
    TtamHighSetting,
    TtamAudienceEventSelect: Audience.TtamAudienceEventSelect,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const refCustomReTargeting: Ref<Validator | null> = ref(null);
    const { customRetargetingValidator } = Audience.useRules();
    const { audienceEventValidator } = Audience.useAudienceEventRules();
    const _appRetargetingType = computed({
      get: () => adgroupData.value.appRetargetingType,
      set: val => {
        emit('retargeting-type-change', val);
      },
    });
    const onIncludeChange = val => {
      emit('include-change', val);
      refCustomReTargeting.value && refCustomReTargeting.value.validate('change');
    };
    const onExcludeChange = val => {
      emit('exclude-change', val);
    };
    const onIncludeEventChange = val => {
      emit('include-event-change', val);
    };
    const onExcludeEventChange = val => {
      emit('exclude-event-change', val);
    };
    onBeforeMount(() => {
      // 初始化默认 appRetargetingType
      if (_appRetargetingType.value === AppRetargetingType.NONE) {
        _appRetargetingType.value = AppRetargetingType.INCLUDE_INTERACTE_USERS;
      }
    });
    return {
      name,
      _appRetargetingType,
      customRetargetingValidator,
      audienceEventValidator,
      onIncludeChange,
      onExcludeChange,
      onIncludeEventChange,
      onExcludeEventChange,
    };
  },
});
